const dataArray = [
    ["Beaverhead", 13, 526, 2165, 13, 758, 3121],
    ["Big Horn", 58, 416, 1295, 68, 549, 1455],
    ["Blaine", 0, 104, 1344, 0, 118, 1457],
    ["Broadwater", 0, 109, 899, 0, 412, 1759],
    ["Carbon", 9, 2262, 1276, 12, 3769, 1595],
    ["Carter", 0, 482, 19, 0, 568, 27],
    ["Cascade", 0, 617, 19527, 0, 1030, 23861],
    ["Chouteau", 0, 33, 1946, 0, 36, 2144],
    ["Custer", 7, 613, 2836, 14, 910, 3001],
    ["Daniels", 0, 0, 762, 0, 1, 833],
    ["Dawson", 0, 14, 3009, 0, 16, 3226],
    ["Deer Lodge", 0, 600, 2995, 0, 992, 3159],
    ["Fallon", 0, 187, 700, 0, 237, 799],
    ["Fergus", 0, 297, 3482, 0, 428, 4234],
    ["Flathead", 480, 6473, 10645, 976, 14852, 19850],
    ["Gallatin", 6, 2357, 9457, 28, 6191, 24439],
    ["Garfield", 3, 421, 112, 9, 546, 132],
    ["Glacier", 22, 251, 1685, 27, 369, 1816],
    ["Golden Valley", 0, 22, 307, 0, 34, 362],
    ["Granite", 129, 1018, 35, 278, 1724, 63],
    ["Hill", 0, 85, 4134, 0, 110, 4554],
    ["Jefferson", 7, 1340, 1076, 16, 3086, 1635],
    ["Judith Basin", 0, 82, 867, 0, 121, 1025],
    ["Lake", 371, 2229, 4255, 582, 3880, 6728],
    ["Lewis and Clark", 202, 2749, 10166, 277, 6304, 14468],
    ["Liberty", 0, 0, 646, 0, 0, 698],
    ["Lincoln", 174, 3579, 1051, 387, 6481, 1406],
    ["Madison", 5, 289, 2129, 34, 1445, 4085],
    ["McCone", 0, 34, 727, 0, 40, 804],
    ["Meagher", 0, 230, 663, 0, 394, 829],
    ["Mineral", 39, 867, 0, 66, 1529, 0],
    ["Missoula", 1739, 6870, 11058, 2995, 13643, 15194],
    ["Musselshell", 0, 1356, 36, 1, 1822, 60],
    ["Park", 134, 1579, 3213, 212, 3376, 4331],
    ["Petroleum", 0, 161, 10, 0, 235, 11],
    ["Phillips", 0, 103, 1297, 0, 152, 1485],
    ["Pondera", 1, 29, 1647, 1, 37, 1815],
    ["Powder River", 134, 519, 2, 171, 610, 2],
    ["Powell", 108, 840, 953, 170, 1342, 1007],
    ["Prairie", 0, 90, 440, 0, 106, 480],
    ["Ravalli", 5195, 2847, 11, 10217, 5830, 31],
    ["Richland", 0, 20, 2940, 0, 25, 3439],
    ["Roosevelt", 0, 73, 1713, 0, 88, 1885],
    ["Rosebud", 64, 826, 806, 82, 1049, 861],
    ["Sanders", 6, 1422, 1287, 6, 3137, 1830],
    ["Sheridan", 0, 1, 1395, 0, 1, 1504],
    ["Silver Bow", 0, 558, 9874, 0, 1021, 11077],
    ["Stillwater", 3, 992, 1266, 4, 2113, 1832],
    ["Sweet Grass", 28, 368, 855, 34, 679, 1124],
    ["Teton", 1, 201, 1854, 1, 297, 2216],
    ["Toole", 0, 0, 1502, 0, 0, 1662],
    ["Treasure", 0, 55, 213, 0, 87, 240],
    ["Valley", 0, 11, 2621, 0, 14, 2972],
    ["Wheatland", 0, 0, 815, 0, 0, 916],
    ["Wibaux", 0, 20, 312, 0, 24, 353],
    ["Yellowstone", 0, 2763, 27791, 2, 7370, 37632],
];

const dataObj = dataArray.map(row => {
    return {
        county: row[0],
        total_high: row[1],
        total_moderate: row[2],
        total_low: row[3],
        total_: row[1] + row[2] + row[3],
        new_high: row[4],
        new_moderate: row[5],
        new_low: row[6],
        new_: row[4] + row[5] + row[6]
    };
});
export default dataObj;
